var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSupportUser
    ? _c("div", { staticClass: "tile is-parent pl-1" }, [
        _c("section", { staticClass: "tile is-child box" }, [
          _vm._m(0),
          _c("div", { staticClass: "pt-5" }, [
            _c("div", [
              _c("div", { staticClass: "field has-addons" }, [
                _c("p", { staticClass: "control is-expanded" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.serviceProviderEmail,
                        expression: "serviceProviderEmail",
                      },
                    ],
                    staticClass: "input fix-rounded mb-2",
                    attrs: {
                      type: "text",
                      placeholder: "Service Provider Email",
                    },
                    domProps: { value: _vm.serviceProviderEmail },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.serviceProviderEmail = $event.target.value
                        },
                        _vm.onlyAcceptAlphaNumeric,
                      ],
                      blur: _vm.validateServiceProviderEmail,
                    },
                  }),
                  _vm.serviceProviderEmailExist
                    ? _c(
                        "small",
                        {
                          staticClass:
                            "tag is-danger is-flex is-justify-content-center mb-2",
                          staticStyle: { width: "50%" },
                        },
                        [
                          _vm._v(
                            " This email was taken, please choose another one "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "control" }, [
                  _c("button", { staticClass: "button is-static" }, [
                    _vm._v(
                      " " + _vm._s(`@${_vm.serviceProviderDomainName}`) + " "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.companyEmail,
                  expression: "companyEmail",
                },
              ],
              staticClass: "input fix-rounded mb-2",
              attrs: {
                type: "text",
                placeholder: "Company Email",
                disabled: "",
              },
              domProps: { value: _vm.companyEmail },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.companyEmail = $event.target.value
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.companyName,
                  expression: "companyName",
                },
              ],
              staticClass: "input fix-rounded",
              attrs: {
                type: "text",
                placeholder: "Company Name",
                disabled: "",
              },
              domProps: { value: _vm.companyName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.companyName = $event.target.value
                },
              },
            }),
          ]),
          _vm.companyEmail && _vm.companyName
            ? _c("div", [
                _c("div", { staticClass: "pt-5 pb-5" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success mr-5",
                      attrs: {
                        disabled:
                          _vm.routeExists || _vm.isServiceProviderEmailExist,
                      },
                      on: { click: _vm.createEmailRoute },
                    },
                    [_vm._v("Create Route")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      attrs: { disabled: !_vm.routeExists },
                      on: { click: _vm.deleteEmailRoute },
                    },
                    [_vm._v("Delete Route")]
                  ),
                ]),
                _c(
                  "table",
                  {
                    ref: "table",
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth table is-hoverable",
                  },
                  [
                    _vm._m(1),
                    _c("tbody", [
                      _c("tr", [
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.routeMatchInfo)),
                          _c("br"),
                          _vm._v(_vm._s(_vm.routeForwardInfo) + " "),
                        ]),
                        _c("td", [
                          _vm._v(" " + _vm._s(_vm.routeDescription) + " "),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
        _c(
          "div",
          {
            staticClass:
              "notification is-danger is-flex is-justify-content-center is-size-4",
            staticStyle: { width: "50%" },
          },
          [_vm._v(" You do not have permissions on this page ")]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "subtitle" }, [_vm._v("Manage Email Route")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Route")]),
        _c("th", [_vm._v("Description")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }